import React from 'react';
import Typical from 'react-typical'
import banner from '../../../images/banner1.jpg';
import './Banner.css';

const Banner = () => {
    return (
        <div className="banner-container">
            <div className="container pt-5">
                <div className="row">
                    <div className="col-md-6 d-flex align-items-center ">
                        <div className="banner-titles text-light">
                            <h3 className="name-title">Hi, I'm <br /> <span style={{ color: '#B03A2E' }}>MD.EMARAT HOSSAIN</span> </h3>
                            <h1>
                                <Typical
                                    steps={['a FRONT-END DEVELOPER', 1000, 'a MERN STACK DEVELOPER', 1000, 'and a...', 1000, 'SOFTWARE ENGINEER', 1000]}
                                    loop={Infinity}
                                    wrapper="p"
                                />
                            </h1>
                            <a
                                href="https://drive.google.com/uc?export=download&id=1NHgR-pZKHygKZeOBmLTlC2N_FkPdcmuT"
                                download>
                                <button className="btn btn-dark">Download Resume</button>
                            </a>
                        </div>
                    </div>
                    <div className="col-md-6 text-center d-flex align-items-center justify-content-center">
                        <img className="banner img-fluid img-thumbnail h-75 " src={banner} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;